import { createEffect } from 'effector';
import { api } from '../../api/axiosinstance.js';

export const getRequestsListFx = createEffect().use(async () => {
  return (await api().get('contact-form-requests/')).data;
});
